import axios from "../config/axios"

export const recordLog = (code,result,resultType) => axios({
    queryType: "AddSecurityLog",
    code,
    result,
    resultType
}, 'post');

export const getMediaList = () => axios({
    queryType: "medialist"
}, 'post');

export const getMediaDetail = (newsId) => axios({
    queryType: "mediaInfo",
    newsId
}, 'post');

export const register = (email) => axios({
    queryType: "register",
    email
})


// WEBPACK FOOTER //
// ./src/server/getData.js